<ew-mat-dialog-custom urlHelp="https://help.edvisor.io/edwallet/withdrawals">
  <ew-mat-stepper-custom
    [validations]="validations"
    [sendIn]="'penultimate'"
    [textForSendButton]="'shared:next'"
    (send)="send = $event">
    <!-- bank account-->
    <ew-mat-stepper-custom-step
      [classContainer]="'max-w-xl m-auto'"
      [title]="
        type === 'PAYOUT'
          ? 'createWithdrawMoney:providerTitle'
          : 'createWithdrawMoney:bankAccountTitle'
      "
      [subtitle]="
        type === 'PAYOUT'
          ? 'createWithdrawMoney:providerSubtitle'
          : 'createWithdrawMoney:bankAccountSubtitle'
      "
      *ngIf="showFirstStep">
      <ew-select-bank-account
        [width]="'100%'"
        [lookupForProviders]="type === 'PAYOUT'"
        [value]="bankAccount.value.currency"
        [limit]="PAGINATION_LIMIT"
        [version]="2"
        (valueChanged)="
          bankAccount.setValue($event);
          notification.patchValue({ email: $event.email })
        "></ew-select-bank-account>
    </ew-mat-stepper-custom-step>

    <!-- set amount -->
    <ew-mat-stepper-custom-step>
      <div class="text-center grid gap-4 max-w-2xl m-auto">
        <div class="mb-5 text-5xl font-bold">
          {{ confirmationMessage | translate }}
        </div>
      </div>

      <treo-message
        class="mb-10 mx-4"
        [appearance]="unavailableWindowAlert.appearance"
        [showIcon]="unavailableWindowAlert.showIcon"
        [showButtonClose]="unavailableWindowAlert.showButtonClose"
        [type]="unavailableWindowAlert.type"
        *ngIf="isDuringUnavailableTimeRangeWindow === 'unavailable'">
        <div>
          <span>
            <!-- <b>{{ creditCardAlert.title! | translate }}:</b> -->
            {{ unavailableWindowAlert.content | translate }}
          </span>
        </div>
      </treo-message>

      <!-- Currency -->
      <mat-form-field class="pb-1 px-8 w-full">
        <mat-label class="font-semibold">
          {{ 'studentPaymentV2:currencyAccounts' | translate }}
          <small class="text-gray-400">
            ({{ 'shared:required' | translate }})
          </small>
        </mat-label>

        <mat-select class="h-16" [formControl]="currency" required="true">
          <mat-select-trigger *ngIf="currency?.value !== null">
            <div class="flex items-center">
              <img
                class="object-cover w-10 h-10 rounded-full mr-4"
                src="https://flagcdn.com/{{
                  currency.value.currencyIso | currencyCountry
                }}.svg"
                [alt]="'Currency flag for ' + currency?.value.currencyIso"
                loading="lazy" />

              <div class="flex flex-col">
                <span>
                  {{ currency?.value.currencyIso }}
                </span>
                <span class="text-gray-400">
                  {{ 'studentPaymentV2:currentBalance' | translate }}
                  {{ currency?.value.balance | currency }}
                </span>
              </div>
            </div>
          </mat-select-trigger>

          <mat-option
            [value]="item"
            *ngFor="let item of currencies"
            [disabled]="item.balance <= 0">
            <div class="flex items-center">
              <img
                class="object-cover w-6 h-6 rounded-full mr-2"
                src="https://flagcdn.com/{{
                  item.currencyIso | currencyCountry
                }}.svg"
                width="36"
                height="27"
                [alt]="'Currency flag for ' + item.currencyIso"
                loading="lazy" />
              <div class="flex flex-col">
                <span>
                  {{ item.currencyIso }}
                </span>
                <span class="text-gray-400">
                  {{ 'studentPaymentV2:currentBalance' | translate }}
                  {{ item.balance | currency }}
                </span>
              </div>
            </div>
          </mat-option>
        </mat-select>

        <mat-error *ngIf="currency.errors">
          <span>
            {{ 'shared:isRequired' | translate }}
          </span>
        </mat-error>
      </mat-form-field>

      <!-- Amount -->
      <div class="pb-4 px-8">
        <label for="amount-sent">
          <h2 class="text-sm">
            {{ 'createWithdrawMoney:confirmationAmountSentTitle' | translate }}
          </h2>
        </label>
        <span class="font-bold text-5xl mr-2">{{
          getCurrencySymbol(currency.value.currencyIso)
        }}</span>
        <input
          ewPreventScroll
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          class="font-bold text-5xl mb-4"
          [formControl]="amount"
          placeholder="1.00"
          step=".01"
          id="amount-sent" />

        <div>
          <mat-error *ngIf="amount.errors?.min">
            <span class="text-sm">
              {{
                'createWithdrawMoney:confirmationMinimalAmountMessage'
                  | translate
              }}
            </span>
          </mat-error>
          <mat-error *ngIf="amount.errors?.max">
            <span class="text-sm">
              {{
                'createWithdrawMoney:confirmationNotEnoughBalanceMessage'
                  | translate
              }}
            </span>
          </mat-error>
          <mat-error *ngIf="amount.errors?.minAmount">
            <span class="text-sm"
              >{{ 'createWithdrawMoney:amountGreaterThan' | translate }}
              {{ amount.errors?.minAmount }}</span
            >
          </mat-error>
          <mat-error *ngIf="amount.errors?.maxAmount">
            <span class="text-sm"
              >{{ 'createWithdrawMoney:amountLowerThan' | translate }}
              {{ amount.errors?.maxAmount }}</span
            >
          </mat-error>
        </div>

        <!-- fees -->
        <div class="text-gray-500 text-sm" *ngIf="applicableFees.active">
          <p class="relative max-w-fit">
            {{ 'createWithdrawMoney:transactionFees' | translate }}:
            {{ applicableFee }}
            <mat-progress-spinner
              class="absolute top-[50%] translate-y-[-50%] right-[-25px]"
              [diameter]="17"
              [mode]="'indeterminate'"
              *ngIf="loadingRate"></mat-progress-spinner>
          </p>
          <p class="relative max-w-fit">
            {{ 'createWithdrawMoney:transactionTotalWithFees' | translate }}:
            {{ applicableTotalAmount }}
            <mat-progress-spinner
              class="absolute top-[50%] translate-y-[-50%] right-[-25px]"
              [diameter]="17"
              [mode]="'indeterminate'"
              *ngIf="loadingRate"></mat-progress-spinner>
          </p>
        </div>

        <!-- balance -->
        <p
          class="text-sm relative max-w-fit {{
            actualBalance < 0 ? 'text-red-600' : 'text-gray-500'
          }}">
          {{ 'createWithdrawMoney:confirmationAmountSentBalance' | translate }}:
          {{ payoutUpdatedValues.balanceAfter }}
          <mat-progress-spinner
            class="absolute top-[50%] translate-y-[-50%] right-[-25px]"
            [diameter]="17"
            [mode]="'indeterminate'"
            *ngIf="loadingRate"></mat-progress-spinner>
        </p>
        <p *ngIf="actualBalance < 0" class="text-sm text-red-600">
          {{
            'createWithdrawMoney:confirmationNotEnoughBalanceMessage'
              | translate
          }}
        </p>
      </div>

      <!-- Beneficiary Account -->
      <div class="pb-2 px-8">
        <h2 class="text-sm">
          {{
            'createWithdrawMoney:confirmationBeneficiaryAccountTitle'
              | translate
          }}
        </h2>
        <div class="border border-gray-300 rounded-md p-2">
          <ew-table-card-item
            *ngIf="bankAccount.value.currency"
            [img]="
              'https://flagcdn.com/' +
              (bankAccount.value.currency | currencyCountry) +
              '.svg'
            "
            [title]="bankAccount.value.payee.name"
            [subtitle]="
              (bankAccount.value.accountNumber | maskAccountNumber) +
              ' | ' +
              ('country:' + bankAccount.value.country.toUpperCase()
                | translate) +
              ' | ' +
              ('currencyName:' + bankAccount.value.currency | translate)
            "></ew-table-card-item>
        </div>
      </div>

      <!-- Beneficiary Amount -->
      <div class="px-8 py-2">
        <h2 class="text-sm">
          {{
            'createWithdrawMoney:confirmationBeneficiaryAmountTitle' | translate
          }}
        </h2>
        <p class="font-bold text-xl relative max-w-fit">
          {{ payoutUpdatedValues.beneficiaryAmount }}
          <mat-progress-spinner
            class="absolute top-[50%] translate-y-[-50%] right-[-30px]"
            [diameter]="17"
            [mode]="'indeterminate'"
            *ngIf="loadingRate"></mat-progress-spinner>
        </p>
        <p class="text-gray-500 text-sm relative max-w-fit">
          FX RATES:
          {{ payoutUpdatedValues.fxRateBaseCurrency }} =
          {{ payoutUpdatedValues.fxRateDestCurrency }}
          ({{
            'createWithdrawMoney:confirmationBeneficiaryAmountRates'
              | translate
          }})
          <mat-progress-spinner
            class="absolute top-[50%] translate-y-[-50%] right-[-30px]"
            [diameter]="17"
            [mode]="'indeterminate'"
            *ngIf="loadingRate"></mat-progress-spinner>
        </p>
      </div>

      <!-- Type for US and CA only -->
      <div
        class="px-8 pb-4"
        *ngIf="ew1889.variable && bankAccount.value.country === 'us'">
        <mat-label class="font-semibold mb-2">
          <h2 class="text-sm">
            {{ 'transactions:method' | translate }}
          </h2>
        </mat-label>
        <mat-select
          class="block w-full p-2 border rounded-md"
          name="payment-method"
          [formControl]="paymentMethod">
          <mat-option [value]="transferMethod.ACH_TRANSFER">
            {{ 'transactions:methodACHTransfer' | translate }}
          </mat-option>
          <mat-option [value]="transferMethod.DOMESTIC_WIRE_TRANSFER">
            {{ 'transactions:methodDomesticWireTransfer' | translate }}
          </mat-option>
        </mat-select>
      </div>

      <!-- Reference -->
      <mat-form-field
        class="px-8 pb-4 w-full"
        *ngIf="data?.type === 'WITHDRAWAL'">
        <mat-label class="font-bold">
          {{ 'transactions:reference' | translate }}
          <small>({{ 'shared:required' | translate }})</small>
        </mat-label>
        <input
          class="block w-full p-2 border rounded-md"
          matInput
          required
          [formControl]="reference"
          name="reference" />
        <mat-hint>
          {{ 'createWithdrawMoney:referenceHint' | translate }}
        </mat-hint>
        <mat-error *ngIf="reference.errors?.minlength">
          <span>
            {{ reference.errors?.minlength | errorMinValue }}
          </span>
        </mat-error>
        <mat-error *ngIf="reference.errors?.maxlength">
          <span>
            {{ reference.errors?.maxlength | errorMaxValue }}
          </span>
        </mat-error>
        <mat-error *ngIf="reference.errors?.required">
          <span>
            {{ 'shared:isRequired' | translate }}
          </span>
        </mat-error>
        <mat-error *ngIf="reference.errors?.pattern">
          <span>
            {{ 'shared:noSpecialCharacters' | translate }}
          </span>
        </mat-error>
      </mat-form-field>

      <!-- Notification to provider -->
      <form
        class="px-8 pb-4 max-w-3xl"
        [formGroup]="notification"
        *ngIf="data?.type === 'PAYOUT'">
        <div class="mt-6 w-full">
          <h2>
            {{ 'createWithdrawMoney:notificationToProvider' | translate }}
          </h2>
          <!-- reference -->
          <mat-form-field class="w-full">
            <mat-label class="font-bold">
              {{ 'transactions:reference' | translate }}
              <small>({{ 'shared:required' | translate }})</small>
            </mat-label>
            <input
              class="block w-full p-2 border rounded-md"
              matInput
              required
              [formControl]="reference"
              name="reference" />
            <mat-hint>
              {{ 'createWithdrawMoney:referenceHint' | translate }}
            </mat-hint>
            <mat-error *ngIf="reference.errors?.minlength">
              <span>
                {{ reference.errors?.minlength | errorMinValue }}
              </span>
            </mat-error>
            <mat-error *ngIf="reference.errors?.maxlength">
              <span>
                {{ reference.errors?.maxlength | errorMaxValue }}
              </span>
            </mat-error>
            <mat-error *ngIf="reference.errors?.required">
              <span>
                {{ 'shared:isRequired' | translate }}
              </span>
            </mat-error>
            <mat-error *ngIf="reference.errors?.pattern">
              <span>
                {{ 'shared:noSpecialCharacters' | translate }}
              </span>
            </mat-error>
          </mat-form-field>

          <!-- email -->
          <mat-form-field class="w-full">
            <mat-label class="font-bold">
              {{ 'createWithdrawMoney:notificationEmail' | translate }}
              <small>({{ 'shared:required' | translate }})</small>
            </mat-label>
            <input
              matInput
              required
              formControlName="email"
              name="email"
              placeholder="" />
            <mat-error *ngIf="notification.controls['email'].errors">
              <span *ngIf="notification.controls['email'].errors['required']">
                {{ 'shared:isRequired' | translate }}
              </span>
              <span *ngIf="notification.controls['email'].errors['email']">
                {{ 'shared:formatEmail' | translate }}
              </span>
              <span *ngIf="notification.controls['email'].errors['maxlength']">
                {{
                  notification.controls['email'].errors['maxlength']
                    | errorMaxValue
                }}
              </span>
            </mat-error>
          </mat-form-field>

          <!-- checkbox -->
          <mat-checkbox [color]="'primary'" formControlName="sendMessage">
            {{ 'createWithdrawMoney:notificationCheckbox' | translate }}
          </mat-checkbox>

          <!-- message -->
          <mat-form-field
            class="w-full"
            *ngIf="notification.controls['sendMessage'].value">
            <textarea
              matInput
              id="text"
              formControlName="message"
              cdkTextareaAutosize
              rows="4"
              #autosize="cdkTextareaAutosize"
              class="whitespace-pre-wrap py-3"></textarea>
            <mat-error *ngIf="notification.controls['message'].errors">
              <span
                *ngIf="notification.controls['message'].errors['maxlength']">
                {{
                  notification.controls['message'].errors['maxlength']
                    | errorMaxValue
                }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </ew-mat-stepper-custom-step>

    <!-- confirmation -->
    <ew-mat-stepper-custom-step>
      <div class="max-w-2xl m-auto pb-2">
        <div class="text-xl font-bold">
          {{ 'createWithdrawMoney:confirmationTitle' | translate }}
        </div>
        <div>
          {{ 'createWithdrawMoney:confirmationSubtitle' | translate }}
        </div>

        <div class="text-md py-10">
          <!-- inputBeneficiaryType -->
          <div class="flex gap-3 mb-1">
            <div class="w-1/3 min-w-[33.33%]">
              {{ 'createBankAccount:inputBeneficiaryType' | translate }}:
            </div>
            <div class="truncate">
              {{
                (bankAccount?.value?.payee?.type === 'corporate'
                  ? 'createBankAccount:inputBeneficiaryTypeOptionCorporate'
                  : 'createBankAccount:inputBeneficiaryTypeOptionIndividual'
                ) | translate
              }}
            </div>
          </div>

          <!-- inputPayeeName -->
          <div class="flex gap-3 mb-1">
            <div class="w-1/3 min-w-[33.33%]">
              {{ 'createBankAccount:inputPayeeName' | translate }}:
            </div>
            <div class="truncate">
              {{ bankAccount?.value?.payee?.name }}
            </div>
          </div>

          <!-- Beneficiary Country -->
          <div class="flex gap-3 mb-1">
            <div class="w-1/3 min-w-[33.33%]">
              {{ 'Beneficiary Country' | translate }}:
            </div>
            <div class="truncate">
              {{
                'country:' + bankAccount?.value?.payee?.country?.toUpperCase()
                  | translate
              }}
              <span *ngIf="bankAccount?.value?.payee?.state">
                ,{{ bankAccount?.value?.payee?.state }}
              </span>
              ,{{ bankAccount?.value?.payee?.city }}
            </div>
          </div>

          <!-- inputPayeeTaxId -->
          <div class="flex gap-3 mb-1" *ngIf="bankAccount?.value?.payee?.taxId">
            <div class="w-1/3 min-w-[33.33%]">
              {{ 'createBankAccount:inputPayeeTaxId' | translate }}:
            </div>
            <div class="truncate">
              {{ bankAccount?.value?.payee?.taxId }}
            </div>
          </div>

          <hr class="my-5" />

          <!-- inputAlias -->
          <div class="flex gap-3 mb-1">
            <div class="w-1/3 min-w-[33.33%]">
              {{ 'createBankAccount:inputAlias' | translate }}:
            </div>
            <div class="truncate">{{ bankAccount?.value?.alias }}</div>
          </div>

          <!-- inputBankName -->
          <div class="flex gap-3 mb-1">
            <div class="w-1/3 min-w-[33.33%]">
              {{ 'createBankAccount:inputBankName' | translate }}:
            </div>
            <div class="truncate">{{ bankAccount?.value?.bankName }}</div>
          </div>

          <!-- inputBankBranchAddress -->
          <div class="flex gap-3 mb-1">
            <div class="w-1/3 min-w-[33.33%]">
              {{ 'createBankAccount:inputBankBranchAddress' | translate }}:
            </div>
            <div class="truncate">
              {{ bankAccount?.value?.address }},
              {{
                'country:' + bankAccount?.value?.country?.toUpperCase()
                  | translate
              }}
              <span *ngIf="bankAccount?.value?.state">
                ,{{ bankAccount?.value?.state }}
              </span>
            </div>
          </div>

          <!-- inputAccountNumber -->
          <div class="flex gap-3 mb-1">
            <div class="w-1/3 min-w-[33.33%]">
              {{ 'createBankAccount:inputAccountNumber' | translate }}:
            </div>
            <div class="truncate">{{ bankAccount?.value?.accountNumber }}</div>
          </div>

          <!-- inputSwift -->
          <div class="flex gap-3 mb-1" *ngIf="bankAccount?.value?.swift">
            <div class="w-1/3 min-w-[33.33%]">
              {{ 'createBankAccount:inputSwift' | translate }}:
            </div>
            <div class="truncate">{{ bankAccount?.value?.swift }}</div>
          </div>

          <!-- inputCurrency -->
          <div class="flex gap-3 mb-1">
            <div class="w-1/3 min-w-[33.33%]">
              {{ 'createBankAccount:inputCurrency' | translate }}:
            </div>
            <div class="truncate">{{ bankAccount?.value?.currency }}</div>
          </div>

          <hr class="my-5" />

          <!-- Amount sent / receive -->
          <div class="flex justify-between items-center mb-1">
            <!-- You´re sending: -->
            <div>
              {{ 'createWithdrawMoney:amountSent' | translate }}:
              <h1>{{ applicableTotalAmount }}</h1>
            </div>

            <i
              class="fa-regular fa-arrow-right fa-2xl"
              style="color: #cccccc"></i>

            <!-- Beneficiary will receive: -->
            <div>
              {{ 'createWithdrawMoney:amountReceive' | translate }}:
              <h1>{{ payoutUpdatedValues.beneficiaryAmount }}</h1>
            </div>
          </div>
        </div>

        <treo-message
          [appearance]="'outline'"
          [showIcon]="true"
          [showButtonClose]="false"
          [type]="'info'">
          <div treoMessageTitle>
            {{ 'createWithdrawMoney:confirmationWarningTitle' | translate }}
          </div>
          <p>
            {{ 'createWithdrawMoney:confirmationWarningContent' | translate }}
            <br />
            {{ 'createWithdrawMoney:confirmationInfoContent' | translate }}
          </p>
        </treo-message>
      </div>
    </ew-mat-stepper-custom-step>

    <!-- loader send -->
    <ew-mat-stepper-custom-step
      [classContainer]="'text-center grid gap-4 max-w-3xl m-auto mb-5'"
      [title]="!validatedCode ? 'createWithdrawMoney:validatedCodeTitle' : ''"
      [subtitle]="
        !validatedCode ? 'createWithdrawMoney:validatedCodeSubtitle' : ''
      "
      [message]="message">
      <img
        class="w-{{
          validatedCode ? '3/5' : '44'
        }} m-auto transition duration-1000 ease-in-out"
        [class.fly]="validatedCode"
        [class.scale-150]="validatedCode"
        *ngIf="validatedCode"
        src="assets/fly.svg"
        alt="" />
      <div *ngIf="!validatedCode" class="transition duration-1000 ease-in-out">
        <ew-validation-code
          class="max-w-xl m-auto"
          (validated)="createWithdrawMoney($event)"
          *ngIf="send"
          [type]="type"
          [hasSubmitted]="lockSendPayoutSubmit"></ew-validation-code>
      </div>
    </ew-mat-stepper-custom-step>
  </ew-mat-stepper-custom>
</ew-mat-dialog-custom>
